import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IAdministrationState } from './state'
import { toNumberDictionary } from '@/utils/groupBy'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import { AloDataSource, getDefaultAloDataSource } from '@/models/alo/AloDataSource'
import { AloMeta } from '@/models/alo/AloMeta'
import { AloFeedDownload, getDefaultAloFeedDownload } from '@/models/alo/AloFeedDownload'
import { AloPersonne, getDefaultAloPersonne } from '@/models/alo/AloPersonne'
import { AloFacetteType, getDefaultAloFacetteType } from '@/models/alo/AloFacetteType'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import { AloGroupCarac, getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac'
import { AloCarac } from '@/models/alo/AloCarac'

const mutations: MutationTree<IAdministrationState> = {
    [types.ADM_PARTENAIRE_REQUEST]: state => {    
        state.partenaireStatus = 'Chargement des partenaire'
    },
    [types.ADM_PARTENAIRE_SUCCESS]: (state, partenaire:Array<AloPartenaire>) => {        
        state.partenaire = {...state.partenaire, ...toNumberDictionary(partenaire,f => f.id)}
        state.partenaireList = buildStateItem(partenaire.map(f => f.id))
        state.partenaireStatus = 'Chargement des partenaire terminé'
    },
    [types.ADM_PARTENAIRE_ERROR]: state => {        
        state.partenaireStatus = 'Erreur lors du chargement des partenaire'
    },
    [types.ADM_PARTENAIRE_DETAIL_REQUEST]: state => {    
        state.partenaireStatus = 'Chargement du detail partenaire'
    },
    [types.ADM_PARTENAIRE_DETAIL_SUCCESS]: (state, partenaire:AloPartenaire) => {                
        Vue.set(state.partenaire,partenaire.id,{...getDefaultAloPartenaire(),...partenaire})
        state.partenaireStatus = 'Chargement du detail partenaire terminé'
    },
    [types.ADM_PARTENAIRE_DETAIL_ERROR]: state => {        
        state.partenaireStatus = 'Erreur lors du chargement du detail partenaire'
    },
    [types.ADM_PARTENAIRE_SAVE_REQUEST]: state => {    
        state.partenaireStatus = 'Sauvegarde du partenaire'
    },
    [types.ADM_PARTENAIRE_SAVE_SUCCESS]: (state, partenaire:AloPartenaire) => {        
        Vue.set(state.partenaire,partenaire.id,{...getDefaultAloPartenaire(),...partenaire})
        state.partenaireStatus = 'Sauvegarde du partenaire terminée'
    },
    [types.ADM_PARTENAIRE_SAVE_ERROR]: state => {        
        state.partenaireStatus = 'Erreur lors de la sauvegarde du partenaire'
    },    
    [types.ADM_PARTENAIRE_RESET_STATUS]: (state) => {
        state.partenaireStatus = ''
    },
    [types.ADM_PARTENAIRE_DELETE_REQUEST]: state => {    
        state.partenaireStatus = "Suppression de partenaire"
    },
    [types.ADM_PARTENAIRE_DELETE_SUCCESS]: (state, partenaire:AloPartenaire) => {        
        const idx = state.partenaireList.item.indexOf(partenaire.id)
        if(idx > -1) state.partenaireList.item.splice(idx ,1)
        delete state.partenaire[partenaire.id]                
        state.partenaireStatus = "Suppression du partenaire terminée"
    },
    [types.ADM_PARTENAIRE_DELETE_ERROR]: state => {        
        state.partenaireStatus = "Erreur lors de la Suppression de partenaire"
    },
    [types.ADM_FLUX_REQUEST]: state => {    
        state.fluxStatus = 'Chargement des flux'
    },
    [types.ADM_FLUX_SUCCESS]: (state, flux:Array<AloFlux>) => {        
        state.flux = {...state.flux, ...toNumberDictionary(flux,f => f.id)}
        state.fluxList = buildStateItem(flux.map(f => f.id))
        state.fluxStatus = 'Chargement des partenaire terminé'
    },
    [types.ADM_FLUX_ERROR]: state => {        
        state.fluxStatus = 'Erreur lors du chargement des flux'    
    },
    [types.ADM_FLUX_DETAIL_REQUEST]: state => {    
        state.fluxStatus = 'Chargement du detail flux'
    },
    [types.ADM_FLUX_DETAIL_SUCCESS]: (state, flux:AloFlux) => {        
        Vue.set(state.flux,flux.id,{...getDefaultAloFlux(),...flux})
        state.fluxStatus = 'Chargement du detail flux terminé'
    },
    [types.ADM_FLUX_DETAIL_ERROR]: state => {        
        state.fluxStatus = 'Erreur lors du chargement du detail flux'    
    },
    [types.ADM_FLUX_SAVE_REQUEST]: state => {    
        state.fluxStatus = 'Sauvegarde du flux'
    },
    [types.ADM_FLUX_SAVE_SUCCESS]: (state, flux:AloFlux) => {        
        Vue.set(state.flux,flux.id,{...getDefaultAloFlux(),...flux})
        state.fluxStatus = 'Sauvegarde du flux terminée'
    },
    [types.ADM_FLUX_SAVE_ERROR]: state => {        
        state.fluxStatus = 'Erreur lors de la sauvegarde du flux'
    }, 
    [types.ADM_FLUX_RESET_STATUS]: (state) => {
      state.fluxStatus = ''
    },
    [types.ADM_FLUX_DELETE_REQUEST]: state => {    
        state.fluxStatus = "Suppression de flux"
    },
    [types.ADM_FLUX_DELETE_SUCCESS]: (state, flux:AloFlux) => {        
        const idx = state.fluxList.item.indexOf(flux.id)
        if(idx > -1) state.fluxList.item.splice(idx ,1)
        delete state.flux[flux.id]                
        state.fluxStatus = "Suppression de flux terminée"
    },
    [types.ADM_FLUX_DELETE_ERROR]: state => {        
        state.fluxStatus = "Erreur lors de la Suppression de flux"
    },
    
    [types.ADM_DATASOURCE_REQUEST]: state => {    
        state.dataSourcesStatus = 'Chargement des dataSources'
    },
    [types.ADM_DATASOURCE_SUCCESS]: (state, dataSources:Array<AloDataSource>) => {        
        state.dataSources = {...state.dataSources, ...toNumberDictionary(dataSources,f => f.id)}
        state.dataSourcesList = buildStateItem(dataSources.map(f => f.id))
        state.dataSourcesStatus = 'Chargement des dataSources terminé'
    },
    [types.ADM_DATASOURCE_ERROR]: state => {        
        state.dataSourcesStatus = 'Erreur lors du chargement des dataSources'    
    },
    [types.ADM_DATASOURCE_DETAIL_REQUEST]: state => {    
        state.dataSourcesStatus = 'Chargement du detail dataSources'
    },
    [types.ADM_DATASOURCE_DETAIL_SUCCESS]: (state, dataSources:AloDataSource) => {   
        dataSources.newId = dataSources.id
        Vue.set(state.dataSources,dataSources.id,{...getDefaultAloDataSource(),...dataSources})
        state.dataSourcesStatus = 'Chargement du detail dataSources terminé'
    },
    [types.ADM_DATASOURCE_DETAIL_ERROR]: state => {        
        state.dataSourcesStatus = 'Erreur lors du chargement du detail dataSources'    
    },
    [types.ADM_DATASOURCE_SAVE_REQUEST]: state => {    
        state.dataSourcesStatus = 'Sauvegarde du dataSources'
    },
    [types.ADM_DATASOURCE_SAVE_SUCCESS]: (state, dataSources:AloDataSource) => {        
        if(dataSources.newId != 0 && dataSources.newId != dataSources.id){
            state.dataSourcesList.item.splice(state.dataSourcesList.item.indexOf(dataSources.newId) ,1,dataSources.id)
            delete state.dataSources[dataSources.newId]    
        }
        dataSources.newId = dataSources.id
        Vue.set(state.dataSources,dataSources.id,{...getDefaultAloDataSource(),...dataSources})
        state.dataSourcesStatus = 'Sauvegarde du dataSources terminée'
    },
    [types.ADM_DATASOURCE_SAVE_ERROR]: state => {        
        state.dataSourcesStatus = 'Erreur lors de la sauvegarde du dataSources'
    }, 
    [types.ADM_DATASOURCE_RESET_STATUS]: (state) => {
      state.dataSourcesStatus = ''
    },
    [types.ADM_DATASOURCE_DELETE_REQUEST]: state => {    
        state.dataSourcesStatus = 'Suppression du dataSources'
    },
    [types.ADM_DATASOURCE_DELETE_SUCCESS]: (state, dataSources:AloDataSource) => {        
        state.dataSourcesList.item.splice(state.dataSourcesList.item.indexOf(dataSources.id) ,1)
        delete state.dataSources[dataSources.id]                
        state.dataSourcesStatus = 'Suppression du dataSources terminée'
    },
    [types.ADM_DATASOURCE_DELETE_ERROR]: state => {        
        state.dataSourcesStatus = 'Erreur lors de la Suppression du dataSources'
    }, 
    
    [types.ADM_FEEDDOWNLOAD_REQUEST]: state => {    
        state.feedDownloadsStatus = 'Chargement des feedDownloads'
    },
    [types.ADM_FEEDDOWNLOAD_SUCCESS]: (state, feedDownloads:Array<AloFeedDownload>) => {        
        state.feedDownloads = {...state.feedDownloads, ...toNumberDictionary(feedDownloads,f => f.id)}
        state.feedDownloadsList = buildStateItem(feedDownloads.map(f => f.id))
        state.feedDownloadsStatus = 'Chargement des feedDownloads terminé'
    },
    [types.ADM_FEEDDOWNLOAD_ERROR]: state => {        
        state.feedDownloadsStatus = 'Erreur lors du chargement des feedDownloads'    
    },
    [types.ADM_FEEDDOWNLOAD_DETAIL_REQUEST]: state => {    
        state.feedDownloadsStatus = 'Chargement du detail feedDownloads'
    },
    [types.ADM_FEEDDOWNLOAD_DETAIL_SUCCESS]: (state, feedDownloads:AloFeedDownload) => {   
        feedDownloads.newId = feedDownloads.id
        Vue.set(state.feedDownloads,feedDownloads.id,{...getDefaultAloFeedDownload(),...feedDownloads})
        state.feedDownloadsStatus = 'Chargement du detail feedDownloads terminé'
    },
    [types.ADM_FEEDDOWNLOAD_DETAIL_ERROR]: state => {        
        state.feedDownloadsStatus = 'Erreur lors du chargement du detail feedDownloads'    
    },
    [types.ADM_FEEDDOWNLOAD_SAVE_REQUEST]: state => {    
        state.feedDownloadsStatus = 'Sauvegarde du feedDownloads'
    },
    [types.ADM_FEEDDOWNLOAD_SAVE_SUCCESS]: (state, feedDownloads:AloFeedDownload) => {        
        if(feedDownloads.newId != 0 && feedDownloads.newId != feedDownloads.id){
            state.feedDownloadsList.item.splice(state.feedDownloadsList.item.indexOf(feedDownloads.newId) ,1,feedDownloads.id)
            delete state.feedDownloads[feedDownloads.newId]    
        }
        feedDownloads.newId = feedDownloads.id
        Vue.set(state.feedDownloads,feedDownloads.id,{...getDefaultAloFeedDownload(),...feedDownloads})
        state.feedDownloadsStatus = 'Sauvegarde du feedDownloads terminée'
    },
    [types.ADM_FEEDDOWNLOAD_SAVE_ERROR]: state => {        
        state.feedDownloadsStatus = 'Erreur lors de la sauvegarde du feedDownloads'
    }, 
    [types.ADM_FEEDDOWNLOAD_RESET_STATUS]: (state) => {
      state.feedDownloadsStatus = ''
    },
    [types.ADM_FEEDDOWNLOAD_DELETE_REQUEST]: state => {    
        state.feedDownloadsStatus = 'Suppression du feedDownloads'
    },
    [types.ADM_FEEDDOWNLOAD_DELETE_SUCCESS]: (state, feedDownloads:AloFeedDownload) => {        
        state.feedDownloadsList.item.splice(state.feedDownloadsList.item.indexOf(feedDownloads.id) ,1)
        delete state.feedDownloads[feedDownloads.id]                
        state.feedDownloadsStatus = 'Suppression du feedDownloads terminée'
    },
    [types.ADM_FEEDDOWNLOAD_DELETE_ERROR]: state => {        
        state.feedDownloadsStatus = 'Erreur lors de la Suppression du feedDownloads'
    }, 

    //////////////////////////////////////////////////////////////////
    // PERSONNE
    /////////////////////////////////////////////////////////////////

    [types.ADM_PERSONNE_REQUEST]: state => {    
        state.personneStatus = 'Chargement des personne'
    },
    [types.ADM_PERSONNE_SUCCESS]: (state, personne:Array<AloPersonne>) => {        
        state.personneDic = {...state.personneDic, ...toNumberDictionary(personne,f => f.id,getDefaultAloPersonne)}
        state.personneList = buildStateItem(personne.map(f => f.id))
        state.personneStatus = 'Chargement des personne terminé'
    },
    [types.ADM_PERSONNE_ERROR]: state => {        
        state.personneStatus = 'Erreur lors du chargement des personne'
    },
    [types.ADM_PERSONNE_DETAIL_REQUEST]: state => {    
        state.personneStatus = "Chargement du detail de personne"
    },
    [types.ADM_PERSONNE_DETAIL_SUCCESS]: (state, personne:AloPersonne) => {        
        Vue.set(state.personneDic,personne.id,{...getDefaultAloPersonne(),...personne})
        state.personneStatus = 'Chargement du detail personne terminé'
    },
    [types.ADM_PERSONNE_DETAIL_ERROR]: state => {        
        state.personneStatus = 'Erreur lors du chargement du detail personne'
    },
    [types.ADM_PERSONNE_SAVE_REQUEST]: state => {    
        state.personneStatus = "Sauvegarde de personne"
    },
    [types.ADM_PERSONNE_SAVE_SUCCESS]: (state, personne:AloPersonne) => {        
        Vue.set(state.personneDic,personne.id,{...getDefaultAloPersonne(),...personne})
        //si l'id n'est pas dans la liste alors on l'ajoute
        if(state.personneList.item.findIndex(n => n == personne.id) == -1) state.personneList.item.push(personne.id)
        state.personneStatus = "Sauvegarde de personne terminée"
    },
    [types.ADM_PERSONNE_SAVE_ERROR]: state => {        
        state.personneStatus = "Erreur lors de la sauvegarde de personne"
    },    
    [types.ADM_PERSONNE_RESET_STATUS]: (state) => {
        state.personneStatus = ''
    },
    [types.ADM_PERSONNE_DELETE_REQUEST]: state => {    
        state.personneStatus = "Suppression de personne"
    },
    [types.ADM_PERSONNE_DELETE_SUCCESS]: (state, personne:AloPersonne) => {        
        const idx = state.personneList.item.indexOf(personne.id)
        if(idx > -1) state.personneList.item.splice(idx ,1)
        delete state.personneDic[personne.id]                
        state.personneStatus = "Suppression de personne terminée"
    },
    [types.ADM_PERSONNE_DELETE_ERROR]: state => {        
        state.personneStatus = "Erreur lors de la Suppression de personne"
    },
    //////////////////////////////////////////////////////////////////
    // PROFIL_EXCLUSION
    /////////////////////////////////////////////////////////////////
    [types.ADM_PROFIL_EXCLUSION_REQUEST]: state => {    
        state.profilExclusionStatus = 'Chargement des profilExclusion'
    },
    [types.ADM_PROFIL_EXCLUSION_SUCCESS]: (state, profilExclusion:Array<AloProfilExclusion>) => {        
        state.profilExclusion = {...state.profilExclusion, ...toNumberDictionary(profilExclusion,f => f.id)}
        state.profilExclusionList = buildStateItem(profilExclusion.map(f => f.id))
        state.profilExclusionStatus = 'Chargement des partenaire terminé'
    },
    [types.ADM_PROFIL_EXCLUSION_ERROR]: state => {        
        state.profilExclusionStatus = 'Erreur lors du chargement des profilExclusion'    
    },
    [types.ADM_PROFIL_EXCLUSION_DETAIL_REQUEST]: state => {    
        state.profilExclusionStatus = 'Chargement du detail profilExclusion'
    },
    [types.ADM_PROFIL_EXCLUSION_DETAIL_SUCCESS]: (state, profilExclusion:AloProfilExclusion) => {        
        Vue.set(state.profilExclusion,profilExclusion.id,{...getDefaultAloProfilExclusion(),...profilExclusion})
        state.profilExclusionStatus = 'Chargement du detail profilExclusion terminé'
    },
    [types.ADM_PROFIL_EXCLUSION_DETAIL_ERROR]: state => {        
        state.profilExclusionStatus = 'Erreur lors du chargement du detail profilExclusion'    
    },
    [types.ADM_PROFIL_EXCLUSION_SAVE_REQUEST]: state => {    
        state.profilExclusionStatus = 'Sauvegarde du profilExclusion'
    },
    [types.ADM_PROFIL_EXCLUSION_SAVE_SUCCESS]: (state, profilExclusion:AloProfilExclusion) => {        
        Vue.set(state.profilExclusion,profilExclusion.id,{...getDefaultAloProfilExclusion(),...profilExclusion})
        state.profilExclusionStatus = 'Sauvegarde du profilExclusion terminée'
    },
    [types.ADM_PROFIL_EXCLUSION_SAVE_ERROR]: state => {        
        state.profilExclusionStatus = 'Erreur lors de la sauvegarde du profilExclusion'
    }, 
    [types.ADM_PROFIL_EXCLUSION_RESET_STATUS]: (state) => {
      state.profilExclusionStatus = ''
    },
    [types.ADM_PROFIL_EXCLUSION_DELETE_REQUEST]: state => {    
        state.profilExclusionStatus = "Suppression de profilExclusion"
    },
    [types.ADM_PROFIL_EXCLUSION_DELETE_SUCCESS]: (state, profilExclusion:AloProfilExclusion) => {        
        const idx = state.profilExclusionList.item.indexOf(profilExclusion.id)
        if(idx > -1) state.profilExclusionList.item.splice(idx ,1)
        delete state.profilExclusion[profilExclusion.id]                
        state.profilExclusionStatus = "Suppression de profilExclusion terminée"
    },
    [types.ADM_PROFIL_EXCLUSION_DELETE_ERROR]: state => {        
        state.profilExclusionStatus = "Erreur lors de la Suppression de profilExclusion"
    },
    //////////////////////////////////////////////////////////////////
    // GROUP_CARAC
    /////////////////////////////////////////////////////////////////
    [types.ADM_GROUP_CARAC_REQUEST]: state => {    
        state.groupCaracStatus = 'Chargement des groupCarac'
    },
    [types.ADM_GROUP_CARAC_SUCCESS]: (state, groupCarac:Array<AloGroupCarac>) => {        
        state.groupCarac = {...state.groupCarac, ...toNumberDictionary(groupCarac,f => f.id)}
        state.groupCaracList = buildStateItem(groupCarac.map(f => f.id))
        state.groupCaracStatus = 'Chargement des partenaire terminé'
    },
    [types.ADM_GROUP_CARAC_ERROR]: state => {        
        state.groupCaracStatus = 'Erreur lors du chargement des groupCarac'    
    },
    [types.ADM_GROUP_CARAC_DETAIL_REQUEST]: state => {    
        state.groupCaracStatus = 'Chargement du detail groupCarac'
    },
    [types.ADM_GROUP_CARAC_DETAIL_SUCCESS]: (state, groupCarac:AloGroupCarac) => {        
        Vue.set(state.groupCarac,groupCarac.id,{...getDefaultAloGroupCarac(),...groupCarac})
        state.groupCaracStatus = 'Chargement du detail groupCarac terminé'
    },
    [types.ADM_GROUP_CARAC_DETAIL_ERROR]: state => {        
        state.groupCaracStatus = 'Erreur lors du chargement du detail groupCarac'    
    },
    [types.ADM_GROUP_CARAC_SAVE_REQUEST]: state => {    
        state.groupCaracStatus = 'Sauvegarde du groupCarac'
    },
    [types.ADM_GROUP_CARAC_SAVE_SUCCESS]: (state, groupCarac:AloGroupCarac) => {        
        Vue.set(state.groupCarac,groupCarac.id,{...getDefaultAloGroupCarac(),...groupCarac})
        state.groupCaracStatus = 'Sauvegarde du groupCarac terminée'
    },
    [types.ADM_GROUP_CARAC_SAVE_ERROR]: state => {        
        state.groupCaracStatus = 'Erreur lors de la sauvegarde du groupCarac'
    }, 
    [types.ADM_GROUP_CARAC_RESET_STATUS]: (state) => {
    state.groupCaracStatus = ''
    },
    [types.ADM_GROUP_CARAC_DELETE_REQUEST]: state => {    
        state.groupCaracStatus = "Suppression de groupCarac"
    },
    [types.ADM_GROUP_CARAC_DELETE_SUCCESS]: (state, groupCarac:AloGroupCarac) => {        
        const idx = state.groupCaracList.item.indexOf(groupCarac.id)
        if(idx > -1) state.groupCaracList.item.splice(idx ,1)
        delete state.groupCarac[groupCarac.id]                
        state.groupCaracStatus = "Suppression de groupCarac terminée"
    },
    [types.ADM_GROUP_CARAC_DELETE_ERROR]: state => {        
        state.groupCaracStatus = "Erreur lors de la Suppression de groupCarac"
    },
    [types.ADM_CARAC_REQUEST]: state => {    
        state.caracStatus = 'Chargement des caractéristiques'
    },
    [types.ADM_CARAC_SUCCESS]: (state, carac:Array<AloCarac>) => {        
        state.carac = {...state.carac, ...toNumberDictionary(carac,f => f.cavIdxc)}
        state.caracList = buildStateItem(carac.map(f => f.cavIdxc))
        state.caracStatus = 'Chargement des caractéristiques terminé'
    },
    [types.ADM_CARAC_ERROR]: state => {        
        state.caracStatus = 'Erreur lors du chargement des caractéristiques'    
    },

  }

export default mutations